interface Coupon {
  usedCouponsResult?: {
    totalAmount?: number;
    booklets?: Array<{
      _id: string;
      amount: number;
    }>;
  };
}

interface Booklet {
  _id: string;
}

/**
 * Calculates the total amount for a coupon based on visible booklets
 * @param coupon - The coupon object with usedCouponsResult
 * @param filteredBooklets - Array of visible booklets
 * @returns Total amount for visible booklets
 */
export const calculateCouponTotalForVisibleBooklets = (
  coupon: Coupon,
  filteredBooklets: Booklet[]
): number => {
  // Om inga häften är valda för filtrering, visa totalt antal för alla häften
  if (!filteredBooklets || filteredBooklets.length === 0) {
    return coupon.usedCouponsResult?.totalAmount || 0;
  }

  // Summera värden från synliga häften för denna kupong
  let totalForVisibleBooklets = 0;

  if (coupon.usedCouponsResult?.booklets) {
    coupon.usedCouponsResult.booklets.forEach(bookletOrder => {
      // Kolla om detta häfte är synligt
      const isBookletVisible = filteredBooklets.some(visibleBooklet =>
        visibleBooklet._id === bookletOrder._id
      );

      if (isBookletVisible) {
        totalForVisibleBooklets += bookletOrder.amount || 0;
      }
    });
  }

  return totalForVisibleBooklets;
};

/**
 * Calculates the total amount for all coupons of a company based on visible booklets
 * @param coupons - Array of coupon objects
 * @param filteredBooklets - Array of visible booklets
 * @returns Total amount for all coupons in visible booklets
 */
export const calculateCompanyTotalForVisibleBooklets = (
  coupons: Coupon[],
  filteredBooklets: Booklet[]
): number => {
  return coupons.reduce((acc, coupon) => {
    acc += calculateCouponTotalForVisibleBooklets(coupon, filteredBooklets);
    return acc;
  }, 0);
};
